
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_y1yrh_1uvaa_99",
  "root": "awsui_root_y1yrh_1uvaa_117",
  "series--highlighted": "awsui_series--highlighted_y1yrh_1uvaa_129",
  "series--dimmed": "awsui_series--dimmed_y1yrh_1uvaa_133",
  "series--threshold": "awsui_series--threshold_y1yrh_1uvaa_137",
  "popover-divider": "awsui_popover-divider_y1yrh_1uvaa_142"
};
  